import { Button, Stack, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import useAddAttachmentStyles from './useAddAttachmentStyles';
import { MAX_TOTAL_SIZE_TICKET_REPLY_MB } from '../constants';

interface AddAttachmentsProps {
  handleFiles: (files: FileList | null) => void;
  selectedFiles?: FileList | null;
  showFileSizeLimitWarning?: boolean;
}

const AddAttachments = (props: AddAttachmentsProps) => {
  const {
    handleFiles,
    selectedFiles,
    showFileSizeLimitWarning = false,
  } = props;

  const filesArray = selectedFiles ? Array.from(selectedFiles) : [];
  const classes = useAddAttachmentStyles();

  return (
    <label htmlFor="file-upload-input">
      <Stack sx={classes.textAndWarningContainer}>
        <Button component="span" startIcon={<AttachFileIcon />}>
          Attach Files {filesArray.length > 0 ? `(${filesArray.length})` : ''}
        </Button>
        {showFileSizeLimitWarning && (
          <Typography variant="caption" sx={classes.fileSilzeWarningText}>
            Total file size exceeds {MAX_TOTAL_SIZE_TICKET_REPLY_MB} MB. Please
            select fewer or smaller files.
          </Typography>
        )}
      </Stack>
      <input
        type="file"
        id="file-upload-input"
        multiple
        onChange={(e) => handleFiles(e?.target?.files)}
        style={classes.fileInput}
      />
    </label>
  );
};

export default AddAttachments;
